import React from 'react';
import styles from './IconAndTitle.module.css';

type Props = {
  icon?: JSX.Element;
  title?: string;
};

export function IconAndTitle({ icon, title }: Props): JSX.Element {
  if (!icon && !title) {
    return <></>;
  }

  return (
    <div className={styles.iconAndTitleContainer}>
      {icon}
      {title && <span>{title}</span>}
    </div>
  );
}
